import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';

// Import the generated route tree
import { routeTree } from './routeTree.gen';
import { initSentry } from './lib/sentry.js';

import './index.css';

// Create a new router instance
const router = createRouter({ routeTree });

// Init Sentry after router creation so TanStack Router tracing can reference it.
// No-op unless VITE_SENTRY_ENABLED + VITE_SENTRY_DSN are set (prod only).
initSentry(router);

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
